module.exports = __webpack_public_path__ + "img/icon-warning-circle.ddda7f9f.svg";